import { TFunction } from 'i18next';
import * as Yup from 'yup';

import { MissingProfileDataFieldType } from './missingProfileData.enums';
import { MissingProfileFormData } from './missingProfileData.types';

const createFieldValidation: (
  field: MissingProfileFormData,
  t: TFunction,
) => Yup.AnySchema = (
  field: MissingProfileFormData,
  t: TFunction
): Yup.AnySchema => {
  let validationRule: Yup.AnySchema = Yup.mixed();
  switch (field.fieldType) {
    case MissingProfileDataFieldType.Text:
      validationRule = Yup.string();
      break;
    case MissingProfileDataFieldType.Email:
      validationRule = Yup.string().email(t('competence.app.actionRequiredToAccess.missingProfileData.validation.emailFormat'));
      break;
    case MissingProfileDataFieldType.Date:
      validationRule = Yup.string();
      break;
    case MissingProfileDataFieldType.BooleanType:
      validationRule = field.required
        ? Yup.boolean().isTrue()
        : Yup.boolean();
      break;
  }

  if (field.required) {
    validationRule = validationRule.required(t('competence.app.actionRequiredToAccess.missingProfileData.validation.fieldRequired'));
  } else {
    validationRule = validationRule.nullable();
  }

  return validationRule;
};

export const createValidationSchema: (
  section: MissingProfileFormData[],
  t: TFunction
) => Yup.ObjectSchema<Record<string, Yup.AnySchema>> = (
  section: MissingProfileFormData[],
  t: TFunction
): Yup.ObjectSchema<Record<string, Yup.AnySchema>> => {
  const values: Record<string, Yup.AnySchema> = {};
  for (const field of section) {
    values[`${field.name}`] = createFieldValidation(field, t);
  }

  return Yup.object().shape({ ...values });
};
